export default __webpack_public_path__ + "static/media/Miguel-Buencamino-Grid.4918bf29.jpg";